// extracted by mini-css-extract-plugin
module.exports = {"root":"root___sqZoT","item":"item___3895v","title":"title___1GI9S","description":"description___1pG4t","readMore":"readMore___3pbr6","loading":"loading___2NNJ-"};